import axios from "axios";
import Request from "./index";

export const getStripeUrlForPurchasingPhotoCredits = async (numPhoto) => {
  return new Promise((resolve, reject) => {
    const payload = { numPhoto: numPhoto };
    Request.post("/purchasePhotoCredit", payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getUserInvoices = async () => {
  return new Promise((resolve, reject) => {
    Request.get("/getUserInvoices")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
